<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Edit Gadai Emas</h5>
            </template>
        
            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA PENDUKUNG</h6>
                    <div>
                        <b-button variant="pgiBtn" class="mb-2" @click="addFotoPendukung" name="fotoPendukungAddBtn"><i class="fa fa-plus mr-2"></i>Foto Pendukung</b-button>
                        <div class="text-danger mt-2 mb-2" v-show="fotoPendukungError">* Foto Pendukung Maksimal {{ input.foto.length }} Foto</div>
                        <FotoPendukungNonBaseFile 
                            v-for="item in input.foto" 
                            v-bind:key="item.index" 
                            :fotoPendukung="item" 
                            :length="input.foto.length" 
                            :minLength="minLengthFotoPendukung"
                            :lat="lat"
                            :long="long"
                            :isDisabledChange="item.isDisabledChange"
                            @remove="removeFotoPendukung"
                            @showModalCam="openModalCam" 
                            @showModalPreview="openModalPreview"
                        />
                    </div>
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">ALASAN PERUBAHAN</h6>
                    <b-form-group label="Keterangan/ Alasan Perubahan">
                        <b-form-textarea
                            id="textarea"
                            v-model="input.alasanPerubahan" name="alasanPerubahan"
                            rows="3"
                            max-rows="6"
                            required
                        ></b-form-textarea>
                    </b-form-group>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="gadaiUpdateBtn" variant="primary">Update</b-button>
                </div>
            </b-form>
        </b-card>
        <ModalConfirm id="modal-confirm-edit" title="Confirm Edit Gadai Emas" alertMessage="Perubahan ini akan diperiksa dan disetujui oleh AM terlebih dahulu sebelum data gadai diubah" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah gadai emas ini?" @submit="onSubmit" />
        <ModalWebCam @photoTaken="setResult"  />
        <ModalPreview :fotoPreview="activeFotoPreview" />
    </div>
</template>

<script>
import FotoPendukungNonBaseFile from '../../../components/webcam/FotoPendukungNonBaseFile'
import ModalWebCam from '../../../components/webcam/ModalWebCam'
import ModalPreview from '../../../components/webcam/ModalPreview'

export default {
    name: 'edit-gadai-emas',
    components: {
        FotoPendukungNonBaseFile,
        ModalWebCam,
        ModalPreview
    },
    data(){
        return{
            id: null,
            initStatus: 0,
            isSubmitting: false,
            isLoading: true,
            dataEmas: {
                anggota: [],
                barang: {
                    foto: [],
                },
            },
            input:{
                foto: [],
                spesifikasiJenis:[],
                alasanPerubahan: "",
                dataKondisi: null,
                kelengkapanGadai: [],
            },

            lat :0,
            long:0,

            indexFotoPendukung: 0,
            fotoPendukungError: false,
            activeFotoPendukungIndex: null,
            activeFotoPreviewIndex: null,
            minLengthFotoPendukung: 0,
            activeFotoPreview: "",

            optJenisEmas: [],
            optMerkEmas: [],
            optEmasTipe: [],
            optEmasSpekJenis: [],
            optKelengkapanBarang: [],
            karatOpt:[8,10,12,14,16,18,20,22],

        }
    }, 

    watch: {
        'dataEmas.barang.jenis': function(newVal) {
            if(this.isLoading != true){
                this.optMerkEmas = []
                this.dataEmas.barang.merk = null

                this.optKelengkapanBarang = []
                this.input.kelengkapanGadai = []

                this.optEmasSpekJenis = {
					penambahan : [],
					pengurangan : []
				}
                this.input.spesifikasiJenis = []

                if(newVal == null) { return }

                // Lookup Merk
                this.$axios.get(`barang-merk/jenis/${newVal.id}`).then(response => {
                    this.optMerkEmas = response.data
                })

                // Lookup Kelengkapan Barang
                this.$axios.get(`barang-jenis/kelengkapan?jenisId=${newVal.id}`).then(response => {
                    this.optKelengkapanBarang = response.data
                })

                // Lookup Spek Jenis
                this.$axios.get(`barang-jenis/spesifikasi?jenisId=${newVal.id}`).then(response => {
                    this.optEmasSpekJenis = response.data
                })
            }

        },
        'dataEmas.barang.merk': function(newVal) {

            if(this.isLoading != true){
                this.optEmasTipe = []
                this.dataEmas.barang.tipe = null

                this.optEmasSpekMerk = {
					penambahan : [],
					pengurangan : []
				}
                this.input.spesifikasiBarangMerk = []

                if(newVal == null) { return }

                // Lookup Tipe
                this.$axios.get(`barang-tipe-v2/merk/${newVal.id}`).then(response => {
                    this.optEmasTipe = response.data.types
                })

                // Lookup Spek Merk
                this.$axios.get(`barang-merk/spesifikasi?merkId=${newVal.id}`).then(response => {
                    this.optEmasSpekMerk = response.data
                })
            }

        },
        'dataEmas.barang.tipe': function(newVal) {

            if(this.isLoading != true){
                this.optEmasTahun = []
                this.input.tahunGadai = null

                this.optEmasKondisi = []
                this.input.dataKondisi = null

                if(newVal == null) { return }

                // Lookup Tahun
                this.$axios.get(`barang-tipe-v2/tahun/${newVal.id}`).then(response => {
                    this.optEmasTahun = response.data
                })

                // Lookup Kondisi
                this.$axios.get(`barang-tipe-v2/kondisi/${newVal.id}`).then(response => {

                    this.optEmasKondisi = response.data.map(item => {
                        return { value: item.id, text: item.name }
                    })

                })
            }

        },
    },

    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
			this.id = this.$route.params.id
			

            let getJenisEmas = this.$axios.get(`barang-jenis/emas`).then(response => {
                this.optJenisEmas = response.data
            })

            let getMerkEmas = this.$axios.get(`barang-merk/jenis/251`).then(response => {
                this.optMerkEmas = response.data
            })

			let getSpesifikasiEmas = this.$axios.get("gadai-emas/spesifikasi").then(response =>{
				this.optEmasSpekJenis = response.data
			})

            let getEditEmas = this.$axios.get(`gadai/daftar-gadai/${this.id}/edit`).then(response => {
                this.dataEmas= response.data
    
                //----------------- Inisialisasi Data Foto -----------------
                
                for (var x of this.dataEmas.foto) {
                    this.input.foto.push({
                        index: this.indexFotoPendukung, 
                        id: x.id, 
                        fotoBarangPendukung: null,
                        fotoBarangPendukungBase64: null,
                        activeFotoPendukungBase64: x.name,
                        urlFotoBarangPendukung: x.name,
                        isDisabledChange: true,
                    })
                    this.indexFotoPendukung++
				}

				if(this.dataEmas.barang.jenis.id != null){
                 
                    this.$axios.get(`barang-jenis/kelengkapan?jenisId=${this.dataEmas.barang.jenis.id}`).then(response => {
                    
                        for(var x of response.data){
                            this.optKelengkapanBarang.push({
                                id: x.id,
                                name: x.name,
                                isActive : x.isActive,
                                checked: false
                            })
                        }
                    
                        //----------------- Inisialisasi Kelengkapn -----------------
                        for (var x of this.dataEmas.barang.kelengkapan) {
                        
                            let idx = this.optKelengkapanBarang.findIndex(item => item.name == x.trim());
                            this.optKelengkapanBarang[idx].checked = true 
                            if(idx != -1) this.input.kelengkapanGadai.push(this.optKelengkapanBarang[idx])
                        }
    
                    })
                    this.$axios.get(`barang-jenis/spesifikasi?jenisId=${this.dataEmas.barang.jenis.id}`).then(response => {
                        this.optEmasSpekJenis = response.data
                        for (var x of this.dataEmas.barang.spesifikasi) {
                            //----------------- Inisialisasi Spesifikasi Jenis -----------------
                            
                            let idxSpekJenisPenambahan = this.optEmasSpekJenis.penambahan.findIndex(item => item.id == x.id);
                            if(idxSpekJenisPenambahan >= 0){
                                this.input.spesifikasiJenis.push(this.optEmasSpekJenis.penambahan[idxSpekJenisPenambahan].id)
                            }
                            let idxSpekJenisPengurangan = this.optEmasSpekJenis.pengurangan.findIndex(item => item.id == x.id);
                            if(idxSpekJenisPengurangan >= 0){
                                this.input.spesifikasiJenis.push(this.optEmasSpekJenis.pengurangan[idxSpekJenisPengurangan].id)
                            }
                        }
                    })
                    this.$axios.get(`barang-merk/jenis/${this.dataEmas.barang.jenis.id}`).then(response => {
                        this.optMerkEmas = response.data
                
                        if(this.dataEmas.barang.merk.id != null){
                            this.$axios.get(`barang-merk/spesifikasi?merkId=${this.dataEmas.barang.merk.id}`).then(response => {
                                this.optEmasSpekMerk = response.data
                                for (var x of this.dataEmas.barang.spesifikasi) {
                                    //----------------- Inisialisasi Spesifikasi Merk -----------------
                                    let idxSpekMerkPenambahan = this.optEmasSpekMerk.penambahan.findIndex(item => item.id == x.id);
                                    if(idxSpekMerkPenambahan >= 0){
                                        this.input.spesifikasiMerk.push(this.optEmasSpekMerk.penambahan[idxSpekMerkPenambahan].id)
                                    }
                                    let idxSpekMerkPengurangan = this.optEmasSpekMerk.pengurangan.findIndex(item => item.id == x.id);
                                    if(idxSpekMerkPengurangan >= 0){
                                        this.input.spesifikasiMerk.push(this.optEmasSpekMerk.pengurangan[idxSpekMerkPengurangan].id)
                                    }
                                }
                            })
                            this.$axios.get(`barang-tipe-v2/merk/${this.dataEmas.barang.merk.id}`).then(response => {
                                this.optEmasTipe = response.data.types
                                if(this.dataEmas.barang.tipe.id !=null){
                                    this.$axios.get(`barang-tipe-v2/tahun/${this.dataEmas.barang.tipe.id}`).then(response => {
                                        this.optEmasTahun = response.data
                                        let idxTahunGadai = this.optEmasTahun.findIndex(item=>item.name == this.dataEmas.barang.tahun);
                                        this.input.tahunGadai=this.optEmasTahun[idxTahunGadai]
                                    })
                                    this.$axios.get(`barang-tipe-v2/kondisi/${this.dataEmas.barang.tipe.id}`).then(response => {
                                        this.optEmasKondisi = response.data.map(item => {
                                            return { value: item.id, text: item.name }
                                        })
                                        let dataOptKondisi = JSON.parse(JSON.stringify(this.optEmasKondisi))
                                        let dataGradeKondisi = dataOptKondisi.filter(item=> item.text == this.dataEmas.barang.gradeKondisi.name)
                                        if(dataGradeKondisi.length != 0){
                                            this.input.dataKondisi = dataGradeKondisi[0].value
                                        }else{
                                            this.input.dataKondisi = null
                                        }
                                    })
                                }
                            })
                        }
                    })
                }
            })

            navigator.geolocation.getCurrentPosition(
                position => {
                    this.lat = position.coords.latitude
                    this.long = position.coords.longitude
                },
                error => {
                    console.log(error.message);
                },
            )

            Promise.all([getJenisEmas, getMerkEmas  , getSpesifikasiEmas, getEditEmas]).then(() => {
                this.initStatus = 1
                this.isLoading = false
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        //----------------- Fungsi Submit Data -----------------

        onSubmit() {
                if (!this.$helper.validateArrayHaveValue(this.input.foto, 'activeFotoPendukungBase64')) {
                    this.$helper.toastErr(this, "Harap unggah foto pendukung terlebih dahulu")
                    return;
                }
            
                let payload = new FormData()
                this.id = this.$route.params.id

                //----------------- Append Data Gadai -----------------

                payload.append("id", this.id)
                payload.append("keteranganRevisi ", this.input.alasanPerubahan)

                // Upload photo only if on final step
                let jsonFoto = []
                this.input.foto.forEach(function(entry) {
                    jsonFoto.push(entry.activeFotoPendukungBase64)  
                })
                payload.append("foto", JSON.stringify(jsonFoto))
                
                //----------------- Submit Semua Data -----------------
				this.$helper.printPayload(payload)
                this.isSubmitting = true

                this.$axios.post(`gadai-emas/edit/${this.id}`, payload, { timeout: 300000 }).then(() => {

                    this.initStatus = 1
					this.$helper.setFlash(`Perubahan gadai berhasil diajukan!`)
					if(this.$route.path.includes("inquiry-faktur")){
                        let path = this.$route.path.split('/')
                        path.pop()
                        path.pop()
                        path = path.join("/")
                        this.$router.push({ path })
					}else{
						let path = this.$route.path.split('/')
						path.pop()
						path = path.join("/")
						this.$router.push({ path })
					}
                })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isSubmitting = false
                })
        },

        //----------------- Fungsi Tambah Hapus Data Foto Pendukung -----------------

        addFotoPendukung() {
            if(this.input.foto.length < 30){
                this.input.foto.unshift({ 
                    index: this.indexFotoPendukung, 
                    id: 0, 
                    fotoBarangPendukung: null,
                    fotoBarangPendukungBase64: null,
                    activeFotoPendukungBase64: null,
                    urlFotoBarangPendukung: null,
                    isDisabledChange: false,
                })
                this.indexFotoPendukung++;
            }else{
                this.fotoPendukungError = true;
            }
        },

        removeFotoPendukung(index) {
            this.input.foto = this.input.foto.filter(item => item.index != index)
            this.fotoPendukungError = false;
        },

        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
            this.$bvModal.show("modal-confirm-edit")
        },

        openModalCam(index){
            this.activeFotoPendukungIndex = index
            this.$bvModal.show("modal-ambil-foto")
        },

        openModalPreview(index){
            this.activeFotoPreviewIndex = index
            let idx = this.input.foto.findIndex(item => item.index == this.activeFotoPreviewIndex);
            this.activeFotoPreview = this.input.foto[idx].activeFotoPendukungBase64
            this.$bvModal.show("modal-preview-foto")
        },

        async setResult(result){
            let formattedDate = this.$helper.formatTanggalDMY()
            
           let img = new Image()
           img.src = result
           img.onload = () => {
               let canvas = document.createElement('canvas')
               let ctx = canvas.getContext('2d')
               canvas.setAttribute("width", img.width);
               canvas.setAttribute("height", img.height);
               ctx.drawImage(img, 0, 0,)
               ctx.font = "14pt Arial";
               ctx.fillStyle = "#ffffff"; //<======= here
               ctx.fillText(formattedDate, 10, img.height - 40 ,);
               ctx.strokeText(formattedDate, 10, img.height - 40 ,);
               ctx.fillText(this.lat + ' ' +this.long, 10, img.height - 10 ,);
               ctx.strokeText(this.lat + ' ' +this.long, 10, img.height - 10 ,);
               let newBase64Str = canvas.toDataURL('image/jpeg', 0.9)

               let idx = this.input.foto.findIndex(item => item.index == this.activeFotoPendukungIndex);
               this.input.foto[idx].fotoBarangPendukungBase64 = newBase64Str
               this.input.foto[idx].activeFotoPendukungBase64 = newBase64Str
           }
		},
		
		roundPersen(){
            var desimalBerat = Number(this.dataEmas.barang.berat).toFixed(2);
			this.dataEmas.barang.berat = desimalBerat;
		}
    },
    created(){
        this.init()
    }
}
</script>
